export default __webpack_public_path__ + "static/media/cil_01-1.862ca1bc.jpg";